import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "om-vaccine-order-completion",
  templateUrl: "./vaccine-order-completion.component.html",
  styleUrls: ["./vaccine-order-completion.component.scss"],
})
export class VaccineOrderCompletionComponent implements OnInit {
  dateEntryForm: FormGroup;
  modalRef: NgbModalRef;
  @ViewChild("modal") modal;
  @Output() completed = new EventEmitter();

  constructor(private fb: FormBuilder, private modalService: NgbModal) {
    this.createForm();
  }

  ngOnInit() {}

  createForm() {
    this.dateEntryForm = this.fb.group({
      year: [null, [Validators.required]],
      month: [null],
    });
  }

  open() {
    this.dateEntryForm.reset();
    this.modalRef = this.modalService.open(this.modal);
  }

  close() {
    this.modalRef.close();
  }

  complete() {
    this.completed.emit({
      completionData: {
        year: this.dateEntryForm.controls["year"].value.toString(),
        month:
          this.dateEntryForm.controls["month"].value &&
          this.dateEntryForm.controls["month"].value.monthNumber,
      },
    });
  }
}
